import { nb } from '@/i18n/nb';
import s from './Faq.module.css';

/*
 * Public Vanlige spørsmål (FAQ) placeholder, rendered inside the shared landing
 * slide-overlay (Landing.tsx). Static "Kommer snart" + an invitation to suggest
 * questions by email, rendered as a real mailto: pill. No backend (Iter 11).
 */
export function Faq() {
  return (
    <div className={s.faq}>
      <p className={s.comingSoon}>{nb.modules.comingSoon}</p>
      <p className={s.invitation}>{nb.faq.invitation}</p>
      <a className={s.mailPill} href={`mailto:${nb.faq.email}`} aria-label={nb.faq.emailAria}>
        {nb.faq.email}
      </a>
    </div>
  );
}
